var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.54,0H2.17a2.15,2.15,0,0,0-.93.22L12.31,11.28,14.79,8.9,23.47.22A2.15,2.15,0,0,0,22.54,0Z","key":0}),React.createElement("path",{"d":"M24.49,1.24,16.32,9.41l8.17,8.17a2,2,0,0,0,.22-.93V2.17A2,2,0,0,0,24.49,1.24Z","key":1}),React.createElement("path",{"d":"M.22,1.24A2.15,2.15,0,0,0,0,2.17V16.65a2.15,2.15,0,0,0,.22.93L8.39,9.41Z","key":2}),React.createElement("path",{"d":"M15.3,10.44l-2.48,2.39a.72.72,0,0,1-1,0h0L9.41,10.44,1.24,18.61a2.15,2.15,0,0,0,.93.22H22.54a2.15,2.15,0,0,0,.93-.22Z","key":3})]);
}

Email.defaultProps = {"viewBox":"0 0 24.71 18.83"};

module.exports = Email;

Email.default = Email;
